import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import {
  Mic,
  MicOff,
  Videocam,
  VideocamOff,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { LocalParticipant } from 'livekit-client';

interface VideoControlsProps {
  localParticipant: LocalParticipant | null;
  onToggleVideo: () => Promise<void>;
  onToggleAudio: () => Promise<void>;
}

export const VideoControls: React.FC<VideoControlsProps> = ({
  localParticipant,
  onToggleVideo,
  onToggleAudio,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      position="absolute"
      bottom={8}
      right={8}
      display="flex"
      gap={1}
      bgcolor="rgba(0, 0, 0, 0.7)"
      borderRadius={2}
      p={1}
    >
      <Tooltip title={localParticipant?.isMicrophoneEnabled ? t('Mute') : t('Unmute')}>
        <IconButton
          onClick={onToggleAudio}
          color={localParticipant?.isMicrophoneEnabled ? "default" : "secondary"}
          size="small"
          sx={{
            color: localParticipant?.isMicrophoneEnabled ? 'white' : '#f44336',
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.1)',
            }
          }}
        >
          {localParticipant?.isMicrophoneEnabled ? <Mic /> : <MicOff />}
        </IconButton>
      </Tooltip>

      <Tooltip title={localParticipant?.isCameraEnabled ? t('Turn off camera') : t('Turn on camera')}>
        <IconButton
          onClick={onToggleVideo}
          color={localParticipant?.isCameraEnabled ? "default" : "secondary"}
          size="small"
          sx={{
            color: localParticipant?.isCameraEnabled ? 'white' : '#f44336',
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.1)',
            }
          }}
        >
          {localParticipant?.isCameraEnabled ? <Videocam /> : <VideocamOff />}
        </IconButton>
      </Tooltip>
    </Box>
  );
};
